import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  Breadcrumb,
  FunnelHeader,
  useFunnelRedirects,
} from '@hungryroot/funnel';
import { SignUp } from '@hungryroot/page-signup';
import { Utm } from '@hungryroot/segment';
import { onSignupSuccess } from '../../components/auth/on-signup-success';
import { queryClientOptions } from '../../components/rest/react-query';
import { renderApp } from '../../frontend/react/src/utils/utils';
import './signup.module.css';

const elm = document.createElement('div');
elm.id = 'signup-page-react-root';
document.body.appendChild(elm);
const container = document.getElementById('container');
const parent = container?.parentNode;
if (container !== null) {
  parent?.removeChild(container);
}

function SignupScreen() {
  const redirects = useFunnelRedirects();

  if (redirects === null) {
    return null;
  }

  const queryParams = new URLSearchParams(window.location.search);
  const nextRedirect = queryParams.get('next') ?? undefined;

  return (
    <>
      <Utm search={window.location.search} />
      <SignUp
        nonCheckedOutSignupSuccessUrl={nextRedirect || redirects.afterSignup}
        onNavigate={(route) => {
          window.location.href = route;
        }}
        onSignupSuccess={({ data, provider }) => {
          const { id: userId } = data;
          onSignupSuccess(
            userId,
            nextRedirect || redirects.afterSignup,
            data,
            provider,
            redirects.afterQuiz
          );
        }}
        header={
          <FunnelHeader>
            <Breadcrumb selected="Claim Offer" />
          </FunnelHeader>
        }
      />
    </>
  );
}

renderApp(
  <QueryClientProvider client={new QueryClient(queryClientOptions)}>
    <SignupScreen />
  </QueryClientProvider>,
  'signup-page-react-root'
);
